import { render, staticRenderFns } from "./PostResponseForm.vue?vue&type=template&id=88572518&scoped=true&"
import script from "./PostResponseForm.vue?vue&type=script&lang=js&"
export * from "./PostResponseForm.vue?vue&type=script&lang=js&"
import style0 from "./PostResponseForm.vue?vue&type=style&index=0&id=88572518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88572518",
  null
  
)

export default component.exports